import {
	loadContextActions,
	loadFieldActions,
	loadSearchHubActions,
	SearchEngine,
	CoreEngine,
	AddContextActionCreatorPayload
} from "@coveo/headless";
import { CoveoHeadlessContext } from "components/coveo-headless/types/coveo-headless-types";
import { ThunkExtraArguments } from "@coveo/headless/dist/definitions/app/thunk-extra-arguments";

// These items help with analytics(and searchhub analytics), and the fields to be returned from each run,
export const registerField = (engine: SearchEngine, fields: string[]) => {
	const regfields = fields;
	const action = loadFieldActions(engine).registerFieldsToInclude(regfields);
	engine.dispatch(action);
};

export const registerSearchHub = (engine: SearchEngine, searchHub: string) => {
	const regSearchHub = searchHub;
	const action = loadSearchHubActions(engine).setSearchHub(regSearchHub);
	engine.dispatch(action);
};
export const launchAnalytics = (
	engine: CoreEngine<{}, ThunkExtraArguments>,
	contextData: {
		userType: string;
		userCountry: string;
		userEnv: string;
	}
) => {
	const arrContext = (contextData: CoveoHeadlessContext) => {
		let arr: AddContextActionCreatorPayload[] = [];
		for (const property in contextData) {
			arr.push({
				contextKey: property,
				contextValue: contextData[property as keyof CoveoHeadlessContext]
			});
		}
		return arr;
	};
	arrContext(contextData).map((item) => {
		let action = loadContextActions(engine).addContext(item);
		return engine.dispatch(action);
	});
};
